import { AnyAction } from 'redux'

import { DEFAULT_GROUP_PLOTS_ORDER, MoodMeterGroupOrderKey } from './constants'
import {
  CHANGE_GROUP_PLOTS_NAME_FILTER,
  CHANGE_GROUP_PLOTS_ORDER_FILTER,
  CHANGE_GROUP_PLOTS_PAGE,
} from './actions'

export interface GroupPlotsFiltersState {
  page: number
  nameFilter: string
  orderFilter: MoodMeterGroupOrderKey
}

export const initialGroupPlotsFiltersState = (): GroupPlotsFiltersState => ({
  page: 0,
  nameFilter: '',
  orderFilter: DEFAULT_GROUP_PLOTS_ORDER,
})

export default function groupPlotsFiltersReducer(
  state = initialGroupPlotsFiltersState(),
  action: AnyAction,
): GroupPlotsFiltersState {
  switch (action.type) {
    case CHANGE_GROUP_PLOTS_PAGE:
      return {
        ...state,
        page: action.payload,
      }

    case CHANGE_GROUP_PLOTS_NAME_FILTER:
      return {
        ...state,
        nameFilter: action.payload,
        page: initialGroupPlotsFiltersState().page,
      }

    case CHANGE_GROUP_PLOTS_ORDER_FILTER:
      return {
        ...state,
        orderFilter: action.payload,
        page: initialGroupPlotsFiltersState().page,
      }

    default:
      return state
  }
}
